import { type QueryHookOptions, useQuery } from "@apollo/client";
import { MyPartnerAssistantConversationQuery } from "../graphql/queries";
import type {
  MyPartnerAssistantConversationQueryType,
  MyPartnerAssistantConversationQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useMyPartnerAssistantConversationQuery = (
  options?: QueryHookOptions<
    MyPartnerAssistantConversationQueryType,
    MyPartnerAssistantConversationQueryVariablesType
  >
) => {
  return useQuery<
    MyPartnerAssistantConversationQueryType,
    MyPartnerAssistantConversationQueryVariablesType
  >(MyPartnerAssistantConversationQuery, options);
};
